<template>
  <CCardBody>
    <CDataTable border :items="items" :fields="fields">
      <td slot="consumer_id" slot-scope="{ item }">
        <span v-if="item.consumer_id">
          <ConsumerHoverComponent :id="item.consumer_id" />
        </span>
      </td>

      <td slot="date_time" slot-scope="{ item }">
        {{ item.date_time | moment(datetimeFormat) }}
      </td>

      <td slot="amount" slot-scope="{ item }">
        {{ item.amount | currency100 }}
      </td>
    </CDataTable>
  </CCardBody>
</template>

<script>
import { Common } from '@/constants';
import ConsumerHoverComponent from '@/components/ConsumerHoverComponent.vue';

export default {
  components: { ConsumerHoverComponent },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      datetimeFormat: Common.datetimeFormat,
      fields: [
        {
          key: 'consumer_id',
          label: 'Consumer',
        },
        {
          key: 'date_time',
          label: 'Date and time',
        },
        {
          key: 'amount',
          label: 'Amount',
        },
      ],
    };
  },
};
</script>
